import { finalPageData } from '../../content/finalPageData';
import { FaqItem } from './FaqItem';
import styles from './FaqSection.module.scss';

export function FaqSection() {
  return (
    <section className={styles.section} id="faq" aria-labelledby="faq-title">
      <div className={styles.inner}>
        <header className={styles.intro} data-reveal>
          <p className={styles.eyebrow}>FAQ</p>
          <h2 id="faq-title">Ответы на важные вопросы</h2>
        </header>

        <div className={styles.list} data-reveal data-reveal-delay="1">
          {finalPageData.faqItems.map((item, index) => (
            <FaqItem key={item.id} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
